import makeStyles from '@mui/styles/makeStyles';
import withStyles from '@mui/styles/withStyles';
import createStyles from '@mui/styles/createStyles';
import Radio from '@mui/material/Radio';

export const matSwitchStyle = createStyles({
  root: {
    width: '6.4rem',
    height: '3.4rem',
    padding: 0,
    display: 'flex',
    margin: '1rem 0'
  },
  switchBase: {
    padding: 1,
    transform: 'translateX(2px) translateY(2px)',
    color: 'white',
    '&$checked': {
      transform: 'translateX(3.2rem) translateY(2px)',
      color: 'white',
      '& + $track': {
        opacity: 1,
        backgroundColor: '#005078',
        borderColor: 'white'
      }
    }
  },
  thumb: {
    width: '2.8rem',
    height: '2.8rem',
    boxShadow: 'none'
  },
  track: {
    color: 'white',
    border: `1px solid #d8d8d8`,
    borderRadius: '1.6rem',
    opacity: 1,
    backgroundColor: '#d8d8d8'
  },
  checked: {}
});

export const matDropDownStyle = makeStyles({
  label: {
    marginLeft: '0.4rem',
    fontSize: '1.2rem',
    color: 'grey',
    '&.Mui-focused': {
      color: 'grey' // to overwrite the default behaviour
    }
  },
  select: {
    width: '20rem',
    color: '#2a2a2a',
    fontSize: '1.6rem',
    borderColor: '#d8d8d8',
    borderStyle: 'solid',
    borderWidth: '1px',
    borderRadius: '0',
    backgroundColor: '#fff',
    '&:hover': {
      borderColor: '#d8d8d8'
    },
    '&:focus': {
      borderRadius: '0'
    }
  },
  selectForOtherFilter: {
    width: '27rem'
  },
  selectForRouterFilter: {
    width: '27rem'
  },
  selectForSdoPositonsFilter: {
    width: '38.7rem'
  },
  selectForSdoRequestFilter: {
    width: '16rem'
  },
  selectForFavourites: {
    width: '29.6rem',
    borderColor: '#000',
    '&:hover': {
      borderColor: '#000'
    }
  },
  icon: {
    background: '#ebebeb',
    color: '#737373',
    width: '4rem',
    height: '4.8rem',
    position: 'absolute',
    userSelect: 'none',
    pointerEvents: 'none',
    top: 0,
    right: 0
  },
  list: {
    borderRadius: '0',
    paddingTop: '0',
    paddingBottom: '0',
    background: 'white',
    '& li.Mui-selected': {
      fontWeight: 700
    }
  },
  menuListItem: {
    color: '#4b4f54',
    minWidth: '22.7rem',
    paddingTop: '1rem',
    marginRight: '0.5rem',
    borderBottom: 'solid 1px #eeeeee',
    paddingBottom: '1.5rem'
  }
});

export const matRadio = makeStyles({
  radioStyle: {
    color: '#005078'
  }
});

export const StyledRadio = withStyles({
  root: {
    color: '#97999c',
    '&$checked': {
      color: '#005078'
    }
  },
  checked: {}
})(Radio);

export const matAutocompleteStyle = makeStyles({
  endAdornment: {
    display: 'none'
  },
  autocomplete: {
    '& .MuiInput-formControl': {
      marginTop: 0
    },
    '& .MuiAutocomplete-popper': {
      fontSize: '1.6rem'
    },
    '& .MuiSvgIcon-fontSizeSmall': {
      fontSize: '1.75rem'
    }
  },
  textField: {
    '& .MuiInputBase-root': {
      border: '1px solid rgb(226,226,226)',
      borderRadius: 0,
      height: '5rem',
      paddingLeft: '1rem',
      width: '26rem'
    },
    '& .MuiInputBase-input': {
      color: '#2a2a2a',
      fontSize: '1.6rem',
      fontWeight: 600,
      marginTop: '1.4rem'
    },
    '& .Mui-focused': {
      backgroundColor: '#f3f3f3',
      borderColor: 'transparent'
    },
    '& .MuiOutlinedInput-notchedOutline': {
      display: 'none'
    }
  },
  textFieldLabel: {
    backgroundColor: 'transparent',
    fontSize: '1.6rem',
    fontFamily: 'Open Sans',
    fontWeight: 600,
    marginLeft: '-0.2rem',
    marginTop: '-0.2rem',
    zIndex: 3,

    '&.MuiInputLabel-shrink': {
      backgroundColor: 'transparent',
      borderColor: 'transparent',
      top: '1.5rem',
      marginLeft: '-0.3rem'
    }
  }
});

export const matTextNumberStyle = makeStyles({
  textField: {
    border: '1px solid rgb(226,226,226)',
    borderRadius: 0,
    height: '5rem',
    width: '14.5rem',

    '& .MuiOutlinedInput-root': {
      marginTop: '16px'
    },
    '& .MuiOutlinedInput-input': {
      color: '#2a2a2a',
      fontSize: '1.6rem',
      fontWeight: 600
    },
    '& .MuiInputBase-input': {
      paddingRight: 0
    },
    '& .MuiFormLabel-filled': {
      fontSize: '1.4rem'
    },
    '& .Mui-disabled': {
      backgroundColor: '#f3f3f3'
    },
    '& .MuiOutlinedInput-notchedOutline': {
      display: 'none'
    }
  },
  textFieldAppNumber: {
    minWidth: '14.5rem'
  },
  textFieldLabel: {
    backgroundColor: 'transparent',
    fontSize: '1.6rem',
    fontFamily: 'Open Sans',
    fontWeight: 600,
    paddingLeft: '1rem',
    marginTop: '0.3rem',
    zIndex: 3,
    top: '8px',
    left: '-12px',

    '&.Mui-focused': {
      backgroundColor: 'transparent',
      borderColor: 'transparent',
      fontSize: '1.4rem'
    }
  }
});

export const faqAutocomplete = makeStyles({
  endAdornment: {
    display: 'none'
  },
  autocomplete: {
    '& .MuiInput-formControl': {
      marginTop: 0
    },
    '& .MuiAutocomplete-popper': {
      fontSize: '1.6rem'
    },
    '& .MuiSvgIcon-fontSizeSmall': {
      fontSize: '1.75rem'
    }
  },
  textField: {
    '& .MuiInputBase-root': {
      border: '1px solid rgb(226,226,226)',
      borderRadius: 0,
      height: '5rem',
      paddingLeft: '1rem'
    },
    '& .MuiInputBase-input': {
      color: '#2a2a2a',
      fontSize: '1.6rem',
      fontWeight: 600,
      marginTop: '1.4rem'
    },
    '& .Mui-focused': {
      backgroundColor: '#f3f3f3',
      borderColor: 'transparent'
    },
    '& .MuiOutlinedInput-notchedOutline': {
      display: 'none'
    }
  },
  textFieldLabel: {
    backgroundColor: 'transparent',
    fontSize: '1.6rem',
    fontFamily: 'Open Sans',
    fontWeight: 600,
    marginLeft: '-0.2rem',
    marginTop: '-0.2rem',
    zIndex: 3,

    '&.MuiInputLabel-shrink': {
      top: '1.5rem'
    },

    '&.Mui-focused': {
      backgroundColor: 'transparent',
      borderColor: 'transparent',
      marginLeft: '-0.3rem'
    }
  }
});

export const matTimePickerStyle = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column'
  }
});
